<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="800" persistent)
    v-card(v-if="value").sdo-card.pa-5
      validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
        v-card-title Добавить файл из хранилища
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
        v-card-text
          .grey--text.px-4.pb-4.
            Чтобы добавить файл зайдите в канал хранилища в телеграмме,
            скопируйте ссылку на сообщение с файлом и вставьте в поле "Ссылка"

          validation-provider(
            rules="required"
            name="Название"
            vid="name"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="telegram.name"
              :error-messages="errors"
              label="Название"
              rounded filled
            )
          validation-provider(
            rules="required"
            name="Ссылка"
            vid="link"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="telegram.link"
              :error-messages="errors"
              label="Ссылка"
              rounded filled
            )

        v-card-actions
          v-spacer
          v-btn(
            v-if="editData"
            color="success"
            :loading="buttonLoading"
            @click="handleSubmit(updateTelegram)"
            text
          ) Изменить
          v-btn(
            v-else
            color="success"
            :loading="buttonLoading"
            @click="handleSubmit(addTelegram)"
            text
          ) Добавить
          v-btn(color="warning" @click="close" text) Закрыть
</template>

<script>

export default {
  name: 'AddTelegramDialog',
  props: {
    value: { type: Boolean, default: false },
    lessonInstance: { type: Object, default: null },
    editData: { type: Object, default: null },
  },
  data() {
    return {
      telegram: {
        link: '',
        name: '',
      },
      buttonLoading: false,
    };
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.telegram = { ...this.editData };
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.telegram = {};
      this.$refs.obs.reset();
    },
    addTelegram() {
      if (this.lessonInstance) {
        this.buttonLoading = true;
        this.$rHandler(
          this.$api.telegram.createTelegramStorageLink(this.lessonInstance.id, this.telegram),
          (r) => {
            this.telegram = r.data.data;
            this.buttonLoading = false;
            this.$emit('telegram:add', this.getItem());
            this.close();
          },
          () => {
            this.buttonLoading = false;
          },
        );
      } else {
        this.$emit('telegram:add', this.getItem());
        this.close();
      }
    },
    updateTelegram() {
      if (this.lessonInstance) {
        this.buttonLoading = true;
        this.$rHandler(
          this.$api.telegram.updateTelegramStorageLink(this.telegram.id, this.telegram),
          () => {
            this.buttonLoading = false;
            this.$emit('telegram:edit', this.getItem());
            this.close();
          },
          () => {
            this.buttonLoading = false;
          },
        );
      } else {
        this.$emit('telegram:edit', this.getItem());
        this.close();
      }
    },
    getItem() {
      return { ...this.telegram };
    },
    onEditorActivate() {
      if (this.value && this.editData) {
        this.telegram = { ...this.editData };
      }
    },
  },
};
</script>

<style scoped>

</style>
